module.exports = "/static/assets/873d80b60c072af2e25f0ef2a6b38682.png";